
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiCapacitor03On as ObiCapacitor03OnElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-capacitor-03-on.js';
 
 
 

 
 export const ObiCapacitor03On = createComponent({
   react: React,
   tagName: 'obi-capacitor-03-on',
   elementClass: ObiCapacitor03OnElement,
   events: {
     
   }
  });
 
 